export class UrlBuilder {
  constructor(href = window.location.href) {
    this.href = href;
  }

  clear_all() {
    return this
      .clear_pathname()
      .clear_query();
  }

  clear_pathname() {
    let url = new URL(this.href);
    url.pathname = '';
    return new UrlBuilder(url.toString());
  }

  set_pathname(pathname) {
    let url = new URL(this.href);
    url.pathname = pathname;
    return new UrlBuilder(url.toString());
  }

  append_pathname(pathpart) {
    let url = new URL(this.href);
    // Ensure exactly one slash before pathpart
    const finalPart = "/" + pathpart.replace(/^\/+|\/+$/g, "");
    // Ensure existing pathname ends without a trailing slash
    const firstPart = url.pathname.replace(/\/+$/, "");
    url.pathname = firstPart + finalPart;
    return new UrlBuilder(url.toString());
  }

  clear_query() {
    let h = this.href.split(/[?#]/)[0];
    return new UrlBuilder(h);
  }

  with_query(key, value) {
    let url = new URL(this.href);
    url.searchParams.append(key, value);
    return new UrlBuilder(url.toString());
  }

  with_URLSearchParams(urlSearchParams) {
    if (!(urlSearchParams instanceof URLSearchParams)) {
      throw new Error('Argument must be a instance of URLSearchParams')
    }
    let url = new URL(this.href);
    url.search = urlSearchParams;
    return new UrlBuilder(url.toString());
  }

  as_href() {
    return this.href;
  }
}
